import Notification16 from '@carbon/icons-react/es/notification/16';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { ReactComponent as EmptyTimesheetImage } from 'assets/svgs/empty-timesheet.svg';
import {
  EmptyState as EmptyStateAtom,
  EmptyStateContainer,
} from 'components/atoms/empty-state';

const EmptyStateContainerStyled = styled(EmptyStateContainer)`
  padding-top: calc(var(--spacing-10) + var(--spacing-05));
`;

interface Props {
  userName?: string;
  sendReminder?: () => void;
  className?: string;
}
export const EmptyState: FC<Props> = ({
  userName,
  sendReminder,
  className,
}) => (
  <EmptyStateContainerStyled className={className}>
    <EmptyStateAtom
      image={<EmptyTimesheetImage />}
      title={<FormattedMessage id="timesheets.states.no_timesheet.title" />}
      message={
        userName ? (
          <FormattedMessage
            id="timesheets.states.no_timesheet.description"
            values={{ userName }}
          />
        ) : (
          <FormattedMessage id="timesheets.states.no_timesheet.description.user" />
        )
      }
      primaryCTA={
        sendReminder && (
          <EmptyStateAtom.CallToAction.Primary
            onClick={sendReminder}
            icon={<Notification16 />}
          >
            <FormattedMessage id="timesheets.buttons.send_reminder" />
          </EmptyStateAtom.CallToAction.Primary>
        )
      }
    />
  </EmptyStateContainerStyled>
);
